import { getDomain } from './urls'

const domain = window.location.hostname === 'localhost'
  ? ''
  : `; domain=${getDomain()}`

/**
 * Set a cookie
 *
 * @param {string} name
 * @param {string} value
 * @param {number} days
 * @param {string} options
 */
export const setCookie = (
  name: string,
  value: string,
  days: number = 0,
  options: string = ''
): void => {
  let expires = ''
  if (days) {
    const date = new Date()
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
    expires = `; expires=${date.toUTCString()}`
  }
  document.cookie = `${name}=${value || ''}${expires}${domain}; path=/${options}`
}

/**
 * Get cookie
 *
 * @param {string} name
 * @returns {string | undefined }
 */
export const getCookie = (name: string) => {
  const nameEQ = `${name}=`
  const ca = document.cookie.split(';')
  // TODO - Modernize
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length)
    }
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
  }
}

/**
 * Erase cookie
 *
 * @param {string} name
 */
export const eraseCookie = (name: string): void => {
  document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT${domain};`
}
